import { useTranslation } from "react-i18next";
import React from "react";
import "../styles.css";
import classes from "../questions.module.css";
import {ReactComponent as CORRECT_ICON} from "../../images/grade-question-correct-icon.svg";
import {GRADE_SCHEMA} from "../../utils/constants";

export default function TFQuestionOptionNew({
                                                gradeSchema,
                                                option,
                                                selectedQuestion,
                                                correctAnswers,
                                                handleCorrectAnswerChange,
                                            }) {
    const { t } = useTranslation();
    const {weightage} = selectedQuestion;
    const gradeEnable = gradeSchema !== GRADE_SCHEMA.UNGRADED.key && !!weightage;

    return (

        <div className={classes.optionBarWrapper}>
            {gradeEnable &&
                <div className={classes.optionCheckBoxContainer}>
                    <span
                        tabIndex={0}
                        role="checkbox"
                        aria-checked={correctAnswers.includes(option) ? "true" : "false"}
                        aria-label={t("accessibility.toggleCorrect", {option})}
                        onClick={() => handleCorrectAnswerChange(option)}
                        className={`${classes.optionCheckBox} ${correctAnswers.includes(option) ? classes.active : ""}`}
                    >
                      {correctAnswers.includes(option) && <CORRECT_ICON/>}
                    </span>
                </div>
            }

            <span style={{marginLeft: 15}}>{option}</span>
        </div>
    );
}
